import React from "react";
import { images } from "@img/imagesMap.ts";

type DayOfWeek =
  | "총 배치인원"
  | "월요일"
  | "화요일"
  | "수요일"
  | "목요일"
  | "금요일"
  | "토요일"
  | "일요일";

interface DayTab {
  label: DayOfWeek;
  count: number;
}

interface WeeklyOffDayTabsProps {
  daysOfWeekTabs: DayTab[];
  selectedDay: DayOfWeek;
  setSelectedDay: (day: DayOfWeek) => void;
  activeNurseCnt: number;
}

export default function WeeklyOffDayTabs({
  daysOfWeekTabs,
  selectedDay,
  setSelectedDay,
  activeNurseCnt,
}: WeeklyOffDayTabsProps) {
  return (
    <div className="bg-white rounded-lg overflow-hidden">
      {/* Title */}
      <div className="pb-[32px] pt-[20px]">
        <h2 className="text-[24px] font-bold text-center text-[#0e59c6] font-pretendard">
          요일별 근무자 주휴 배치
        </h2>
      </div>

      {/* Day Tabs */}
      <div className="flex border-b border-gray-200 justify-center">
        <div className="mr-10 flex items-center gap-0.5">
          <img
            src={images.icon_person_black}
            alt=""
            className="mr-[3px]"
            // style={{ height: "1em" }}
          />
          <span className="text-sm mt-1 font-semibold ">{activeNurseCnt}</span>
        </div>
        {daysOfWeekTabs.map((day) => (
          <button
            key={day.label}
            onClick={() => setSelectedDay(day.label)}
            className={`
                            border border-gray-200 rounded-tl-[10px] rounded-tr-[10px]
                            flex-1 py-[5px] px-10 text-center transition-all duration-200 relative max-w-[120px]
                            ${
                              selectedDay === day.label
                                ? "bg-[#0e59c6] text-white"
                                : day.label === "총 배치인원"
                                  ? "bg-[#F0F0F2] text-[#666666]"
                                  : "bg-white text-[#666666] hover:bg-gray-50"
                            }
                        `}
          >
            <div className="flex flex-col justify-center items-center w-full">
              <div className="whitespace-nowrap text-[16px] font-pretendard">
                {day.label}
              </div>
              <div
                className={`text-[12px] mt-1 font-pretendard ${
                  selectedDay === day.label ? "text-white" : "text-gray-500"
                }`}
              >
                {day.count}명
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
